import { gql } from '@apollo/client';
import { ORGANIZATION_FIELDS } from '../../fragments';
import { ArchiveOrganizationProps, CreateOrganizationProps, UpdateOrganizationProps } from './organization.types';
import { OrganizationType } from '../../../types';
import { GET_ENVIRONMENTS, GET_ORGANIZATIONS, GET_ORGANIZATION_BY_ID } from '../../queries';

export const UPDATE_ORGANIZATION = gql`
  ${ORGANIZATION_FIELDS}
  mutation updateOrganization(
  $organizationId: ID!,
  $name: String,
  $email: String,
  $phone1: String,
  $phone2: String,
  $addressLine1: String,
  $addressLine2: String,
  $city: String,
  $province: String,
  $postalCode: String,
  $country: String,
  $uid: ID
  ) {
    updateOrganization(
    organizationId: $organizationId,
    name: $name,
    email: $email,
    phone1: $phone1,
    phone2: $phone2,
    addressLine1: $addressLine1,
    addressLine2: $addressLine2,
    city: $city,
    province: $province,
    postalCode: $postalCode,
    country: $country
    uid: $uid
    ) {
      ...OrganizationFields
    }
  }
`;

export function updateOrganization({
  client,
  organizationId,
  name,
  email,
  phone1,
  phone2,
  addressLine1,
  addressLine2,
  city,
  province,
  postalCode,
  country,
  uid,
}: UpdateOrganizationProps) {
  return client?.mutate<{ updateOrganization: OrganizationType }>({
    mutation: UPDATE_ORGANIZATION,
    variables: {
      organizationId,
      name,
      email,
      phone1,
      phone2,
      addressLine1,
      addressLine2,
      city,
      province,
      postalCode,
      country,
      uid,
    },
    refetchQueries: [
      GET_ORGANIZATIONS,
      GET_ORGANIZATION_BY_ID,
    ],
  });
}

export const CREATE_ORGANIZATION = gql`
  ${ORGANIZATION_FIELDS}
  mutation CreateOrganization(
    $organizationName: String!,
    $appEnvId: String!,
    $uid: ID!,
    $email: String,
    $phone1: String,
    $phone2: String,
    $addressLine1: String,
    $addressLine2: String,
    $city: String,
    $province: String,
    $postalCode: String,
    $country: String,
    $type: String
    ) {
    createOrganization(
      name: $organizationName,
      appEnvId: $appEnvId,
      email: $email,
      phone1: $phone1,
      phone2: $phone2,
      addressLine1: $addressLine1,
      addressLine2: $addressLine2,
      city: $city,
      province: $province,
      postalCode: $postalCode,
      country: $country,
      uid: $uid,
      type: $type
      ) {
      ...OrganizationFields
    }
  }
`;

export function createOrganization({
  client,
  organizationName,
  appEnvId,
  uid,
  email,
  phone1,
  phone2,
  addressLine1,
  addressLine2,
  city,
  province,
  postalCode,
  country,
  type,
}: CreateOrganizationProps) {
  return client?.mutate<{ createOrganization: OrganizationType }>({
    mutation: CREATE_ORGANIZATION,
    variables: {
      organizationName,
      appEnvId,
      uid,
      email,
      phone1,
      phone2,
      addressLine1,
      addressLine2,
      city,
      province,
      postalCode,
      country,
      type,
    },
  });
}

export const ARCHIVE_ORGANIZATION = gql`
mutation ArchiveOrganization($organizationId: ID!){
  archiveOrganization(organizationId: $organizationId){
    organizationId
  }
}`;

export function archiveOrganization({
  client,
  organizationId,
}: ArchiveOrganizationProps) {
  return client?.mutate<{ archiveOrganization: OrganizationType }>({
    mutation: ARCHIVE_ORGANIZATION,
    variables: {
      organizationId,
    },
    refetchQueries: [
      GET_ENVIRONMENTS,
    ],
  });
}
